import { TypographyHeading } from "shared/molecules/typography-layout";
import { ProjectsFilter } from "./filter";
import { Box, InputLabel, Paper, Typography, FormControl, Select, MenuItem, Pagination,Button } from "@mui/material";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import { useEffect, useState } from "react";
import { GET_PROJECTS_LIST } from "utils/graphql/services/live-classes/queries";
import { useLazyQuery } from "@apollo/client";
import NoDataFound from "shared/molecules/no-data";
import { Stack } from "@mui/material"
import { table } from "./helper"
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import ContentRight from "shared/molecules/content-right";
import { Link } from "react-router-dom";
import { useAppSelector } from "hooks/redux";
import { academicTagsUser, checkFeatureAccess } from "utils/role-restriction/helper";
import liveClassClientService from "utils/graphql/liveclassClient";
import { utcToIst } from "utils/time-util/utcIstTime";

const useStyles: any = makeStyles(() => ({
    label: {
        textDecoration: "none",
        textAlign: "center",
        color: indigo[700],
        marginLeft: "80%",
    },
    Btn: {
        backgroundColor: "#3f50b5",
        color: "white",
        width: "90px",
    },
    BtnWrapper: {
        display: "flex",
        gap: "20px",
        justifyContent: "flex-end",
        paddingTop: "10px",
        paddingBottom: "10px",
    },
}));

export default function Projects() {

    const classes = useStyles();
    const [searchPayload, setSearchPayload] = useState({});
    const [page, setPage] = useState(1);
    const [clearValuesTrigger, setClearValuesTrigger] = useState(0);
    const [limit, setLimit] = useState(10);


    const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
    const userRoleStr = profileData?.role;
    const userRole = userRoleStr?.split(",");


    const [getProjectsList, { loading, error, data }] = useLazyQuery(
        GET_PROJECTS_LIST,
        {
            client: liveClassClientService,
        },
    );

    useEffect(() => {
        getProjectsList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload]);

    const projectsData =
              data?.getProjects?.projects?.map((item: any) => ({
                  ...item,
                  createdAt: utcToIst(item.createdAt),
                  updatedAt: utcToIst(item.updatedAt),
              })) || [];
    return (
        <>
            
            <ContentRight>
                <Link to="projects/create" className={classes.label}>
                    <Button variant="contained">Create Project</Button>
                </Link>
            </ContentRight>

            <TypographyHeading sx={{ mb: 2, mt: 2, fontSize: "25px" }}>
                Projects{" "}
            </TypographyHeading>

            <ProjectsFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
                clearValuesTrigger={clearValuesTrigger}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1); // reset to first page
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getProjects?.projects?.length > 0 ? (
                        <SectionTable
                            data={projectsData || []}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getProjects?.totalCount || 0}
                            paginationSegment="false"
                            viewSecondaryData="false"
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Pagination
                            count={Math.ceil(data?.getProjects?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>

            </Paper>
        </>
    )
}